import { Grid, List, ListItem } from "@mui/material";
import { NavLink, useLocation } from "react-router-dom";
import HomeIcon from "./../Assests/Home.svg";
import CompareIcon from "./../Assests/compare.svg";
import Manufacturing from "./../Assests/manufecturing.svg";
import shiftnChangeover from "./../Assests/shift-changeover.svg";
import oeecpt from "./../Assests/oee-cpt.svg";
import SourcingIcon from "./../Assests/sourcing.svg";
import flowsIcon from "./../Assests/flowstab.svg";
// import ooecpt from "./../Assests/ooe-cpt.svg";

import { useSelector } from "react-redux";

const isActiveStyle = {
  textDecoration: "none",
  color: "#ffffff",
  background: "#0921b7",
  width: "100%",
  padding: "10px",
};
const deActiveStyle = {
  textDecoration: "none",
  color: "#000",
  background: "#Ffffff",
  width: "100%",
  padding: "10px",
};

function Sidebar() {
  const selectedCategoryId = useSelector(
    (state: any) => state.InputDataReducers.selectedCategoryId
  );

  // useEffect (() => {
  //   const urls = API_BASE_URL + MENU_ITEMS;
  //   const header = { accept: "application/json", "Content-Type": "application/json" };
  //   getRequest(urls, {useCaseId:selectedUsecaseId,categoryId: selectedCategoryId}, header).then((response) => {
  //     if (response.status === 200 && response.data) {
  //       setIsInitialLoad('true');
  //      // console.log(response.data,"usecase");
  //       let responseArray = [];
  //       responseArray.push(response.data);
  //       setMenuItems(response.data);
  //       //dispatch(displayScenarioListSuccess(response.data));
  //     }
  //   }).catch((error) => {
  //     dispatch(openErrorDialog(error));
  //     //dispatch(displayScenarioListError(error.message));
  //   });
  // },[selectedUsecaseId,selectedCategoryId])

  console.log(selectedCategoryId, 'selectedCategoryId')
  const location: any = useLocation();
  return (
    <div >
      {selectedCategoryId !== 2 ?
      (<List>
        <ListItem className="listItem">
          <NavLink
            to="/Home"
            style={({ isActive }) => (isActive ? isActiveStyle : deActiveStyle)}
            data-toggle="tooltip"
            data-placement="bottom"
            title={"Home"}
          >
            <Grid container spacing={1}>
              <Grid item xs={10} md={10} lg={10}>
                <h4>Home</h4>
                <p>Map View</p>
              </Grid>
              <Grid item xs={2} md={2} lg={2}>
                <img src={HomeIcon} className="image-icon" />
              </Grid>
            </Grid>
          </NavLink>
        </ListItem>
        <ListItem className="listItem">
          <NavLink
            to="/compare"
            style={({ isActive }) => (isActive ? isActiveStyle : deActiveStyle)}
            data-toggle="tooltip"
            data-placement="bottom"
            title={"Compare"}
          >
            <Grid container spacing={1}>
            <Grid item xs={10} md={10} lg={10}>
                <h4>Compare</h4>
                <p>Analysis</p>
              </Grid>
              <Grid item xs={2} md={2} lg={2}>
                <img src={CompareIcon} />
              </Grid>
            </Grid>
          </NavLink>
        </ListItem>
        <ListItem className="listItem">
          <NavLink
            to="/manufacturemaster"
            style={({ isActive }) => (isActive ? isActiveStyle : deActiveStyle)}
            data-toggle="tooltip"
            data-placement="bottom"
            title={"Manufacturing Master"}
          >
            <Grid container spacing={1}>
            <Grid item xs={10} md={10} lg={10}>
                <h4>Manufacturing</h4>
                <p>Master</p>
              </Grid>
              <Grid item xs={2} md={2} lg={2}>
                <img src={Manufacturing} />
              </Grid>
            </Grid>
          </NavLink>
        </ListItem>
        <ListItem className="listItem">
          <NavLink
            to="/shiftchangeover"
            style={({ isActive }) => (isActive ? isActiveStyle : deActiveStyle)}
            data-toggle="tooltip"
            data-placement="bottom"
            title={"Shift & Changeover"}
          >
            <Grid container spacing={1}>
            <Grid item xs={10} md={10} lg={10}>
                <h4>Shift & Changeover</h4>
                <p>Input</p>
              </Grid>
              <Grid item xs={2} md={2} lg={2}>
                <img src={shiftnChangeover} />
              </Grid>
            </Grid>
          </NavLink>
        </ListItem>
        <ListItem className="listItem">
          <NavLink
            to="/landedcost"
            style={({ isActive }) => (isActive ? isActiveStyle : deActiveStyle)}
            data-toggle="tooltip"
            data-placement="bottom"
            title={"Landed Cost input"}
          >
            <Grid container spacing={1}>
            <Grid item xs={10} md={10} lg={10}>
                <h4>Landed Cost</h4>
                <p>Input</p>
              </Grid>
              <Grid item xs={2} md={2} lg={2}>
                <img src={SourcingIcon} />
              </Grid>
            </Grid>
          </NavLink>
        </ListItem>
        <ListItem className="listItem">
          <NavLink
            to="/oeeandcpt"
            style={({ isActive }) => (isActive ? isActiveStyle : deActiveStyle)}
            data-toggle="tooltip"
            data-placement="bottom"
            title={"OEE & CPT input"}
          >
            <Grid container spacing={1}>
            <Grid item xs={10} md={10} lg={10}>
                <h4>OEE & CPT</h4>
                <p>Input</p>
              </Grid>
              <Grid item xs={2} md={2} lg={2}>
                <img src={oeecpt} />
              </Grid>
            </Grid>
          </NavLink>
        </ListItem>
        <ListItem className="listItem">
          <NavLink
            to="/flows"
            style={({ isActive }) => (isActive ? isActiveStyle : deActiveStyle)}
            data-toggle="tooltip"
            data-placement="bottom"
            title={"Flows"}
          >
            <Grid container spacing={1}>
            <Grid item xs={10} md={10} lg={10}>
                <h4>Flows</h4>
                <p>Output Preview</p>
              </Grid>
              <Grid item xs={2} md={2} lg={2}>
                <img src={flowsIcon} />
              </Grid>
            </Grid>
          </NavLink>
        </ListItem>
    
      </List>): 
      (<List>
        <ListItem className="listItem">
          <NavLink
            to="/Home"
            style={({ isActive }) => (isActive ? isActiveStyle : deActiveStyle)}
            data-toggle="tooltip"
            data-placement="bottom"
            title={"Home"}
          >
            <Grid container spacing={1}>
              <Grid item xs={10} md={10} lg={10}>
                <h4>Home</h4>
                <p>Map View</p>
              </Grid>
              <Grid item xs={2} md={2} lg={2}>
                <img src={HomeIcon} className="image-icon" />
              </Grid>
            </Grid>
          </NavLink>
        </ListItem>
        <ListItem className="listItem">
          <NavLink
            to="/compare"
            style={({ isActive }) => (isActive ? isActiveStyle : deActiveStyle)}
            data-toggle="tooltip"
            data-placement="bottom"
            title={"Compare"}
          >
            <Grid container spacing={1}>
            <Grid item xs={10} md={10} lg={10}>
                <h4>Compare</h4>
                <p>Analysis</p>
              </Grid>
              <Grid item xs={2} md={2} lg={2}>
                <img src={CompareIcon} />
              </Grid>
            </Grid>
          </NavLink>
        </ListItem>
        <ListItem className="listItem">
          <NavLink
            to="/nutmanufacturemaster"
            style={({ isActive }) => (isActive ? isActiveStyle : deActiveStyle)}
            data-toggle="tooltip"
            data-placement="bottom"
            title={"Manufacturing Master"}
          >
            <Grid container spacing={1}>
            <Grid item xs={10} md={10} lg={10}>
                <h4>Manufacturing</h4>
                <p>Master</p>
              </Grid>
              <Grid item xs={2} md={2} lg={2}>
                <img src={Manufacturing} />
              </Grid>
            </Grid>
          </NavLink>
        </ListItem>
        <ListItem className="listItem">
          <NavLink
            to="/packagingmaster"
            style={({ isActive }) => (isActive ? isActiveStyle : deActiveStyle)}
            data-toggle="tooltip"
            data-placement="bottom"
            title={"Packaging Master"}
          >
            <Grid container spacing={1}>
            <Grid item xs={10} md={10} lg={10}>
                <h4>Packaging Master</h4>
                <p>Master</p>
              </Grid>
              <Grid item xs={2} md={2} lg={2}>
                <img src={oeecpt} />
              </Grid>
            </Grid>
          </NavLink>
        </ListItem>
        <ListItem className="listItem">
          <NavLink
            to="/nutshiftchangeover"
            style={({ isActive }) => (isActive ? isActiveStyle : deActiveStyle)}
            data-toggle="tooltip"
            data-placement="bottom"
            title={"Shift & Changeover"}
          >
            <Grid container spacing={1}>
            <Grid item xs={10} md={10} lg={10}>
                <h4>Shift & Changeover</h4>
                <p>Input</p>
              </Grid>
              <Grid item xs={2} md={2} lg={2}>
                <img src={shiftnChangeover} />
              </Grid>
            </Grid>
          </NavLink>
        </ListItem>
        <ListItem className="listItem">
          <NavLink
            to="/manufacturingopeandcpt"
            style={({ isActive }) => (isActive ? isActiveStyle : deActiveStyle)}
            data-toggle="tooltip"
            data-placement="bottom"
            title={"OpE & CPT input"}
          >
            <Grid container spacing={1}>
            <Grid item xs={10} md={10} lg={10}>
                <h4>Manufacturing OPE & CPT</h4>
                <p>Input</p>
              </Grid>
              <Grid item xs={2} md={2} lg={2}>
                <img src={SourcingIcon} />
              </Grid>
            </Grid>
          </NavLink>
        </ListItem>

        <ListItem className="listItem">
          <NavLink
            to="/packagingoeeandcpt"
            style={({ isActive }) => (isActive ? isActiveStyle : deActiveStyle)}
            data-toggle="tooltip"
            data-placement="bottom"
            title={"OEE & CPT input"}
          >
            <Grid container spacing={1}>
            <Grid item xs={10} md={10} lg={10}>
                <h4 className="long-label">Packaging OEE & CPT</h4>
                <br></br>
                <p>Input</p>
              </Grid>
              <Grid item xs={2} md={2} lg={2}>
                <img src={oeecpt} />
              </Grid>
            </Grid>
          </NavLink>
        </ListItem>
        <ListItem className="listItem">
          <NavLink
            to="/flows"
            style={({ isActive }) => (isActive ? isActiveStyle : deActiveStyle)}
            data-toggle="tooltip"
            data-placement="bottom"
            title={"flows"}
          >
            <Grid container spacing={1}>
            <Grid item xs={10} md={10} lg={10}>
                <h4>Flows</h4>
                <p>Output Preview</p>
              </Grid>
              <Grid item xs={2} md={2} lg={2}>
                <img src={flowsIcon} />
              </Grid>
            </Grid>
          </NavLink>
        </ListItem>
    
      </List>)
      }
    </div>
  );
}

export default Sidebar;
